// extracted by mini-css-extract-plugin
export default {"wrapper":"ClientNotFound_wrapper__QopRb","header":"ClientNotFound_header__37mKx"};